import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

export interface Error
{
    title: string;
    msg: string;
}

@Injectable({
    providedIn: 'root'
})
export class ErrorService
{
    private title: string;
    private defaultTitle = 'Hov, noget gik galt...';
    private msg: string;
    private defaultMsg = 'Vi har konstateret en uventet fejl – prøv venligst igen.';

    private readonly router: Router;

    constructor(router: Router)
    {
        this.router = router;
    }

    /** Navigates the user to error site.
    * @param {string} title Optional. Error title to be displayed on site.
    * @param {string} msg Optional. Error message to be displayed on site.
    **/
    public throwError(title?: string, msg?: string)
    {
        if (title ? this.title = title : this.title = this.defaultTitle)
            if (msg ? this.msg = msg : this.msg = this.defaultMsg)
                this.router.navigate(['/fejl']);
    }

    /** Returns the error thrown.
    * @type {Error} The title and message of the error thrown.
    * @property {string} title
    * @property {string} msg
    **/
    public getErrorMsg(): Error
    {
        return {
            title: this.title ? this.title : this.defaultTitle,
            msg: this.msg ? this.msg : this.defaultMsg
        };
    }
}
